// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 *  Shared Seacom Widget styles
 *
 *  Index (Ctrl+F to locate): 
 *   #normal Normal (and Light Theme) Styles
 *   #dark Dark Theme Styles
 *   #media Media Selectors Styles
 *
 */
/*
 * Normal Styles: #normal
 */
/* Safari 7.1+ */
_::-webkit-full-page-media,
_:future,
:root ion-card {
  height: 330px;
}

.digim-notification-top-right {
  position: absolute;
  top: -10px;
  right: 10px;
  height: 30px;
  width: 30px;
  transition: 0.6s;
  font-size: 1rem;
  z-index: 1;
}

.dispatcher-home-card ion-card-header {
  padding: 0;
}

.dispatcher-home-card ion-card-content {
  flex: 1 1 auto;
  padding: 0;
}

.responsive_card {
  background: none !important;
  margin: auto auto !important;
}

.widget-content {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.widget-content-row {
  flex-grow: 1;
  justify-content: center;
}

.widget-button-row {
  flex-shrink: 1;
  display: flex;
  justify-content: center;
}

div.digim-ionic-card-center {
  height: 100%;
  align-items: flex-start;
}

.digim-ionic-card-center ion-card-content {
  height: 200px;
  width: 100%;
}

.digim-card-heading {
  font-size: 22px;
  color: var(--color-black-light);
  display: inline-block;
  text-transform: capitalize;
  font-family: Calibri;
  width: 90%;
  font-weight: 600;
}

.digim-text-card-title {
  display: block;
  font-size: 4em;
  color: var(--color-black-light);
  text-align: center;
  width: 100%;
  font-family: Calibri;
}

.digim-small-text {
  padding: 0px 0 0px 5px;
  font-size: 13px;
  color: var(--color-black-light);
  text-align: center;
  width: 100%;
  font-weight: bold;
  margin-bottom: 10px;
}

.digim-center {
  display: block;
  text-align: center;
}

.digim-center {
  display: block;
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 15px;
}

.digim-button-1 {
  --background: var(--color-blue-1-light);
  --border-radius: 5px;
  font-weight: lighter;
  height: 32px;
  width: 85px;
  text-transform: capitalize;
  --border-color: var(--color-blue-1-light);
  --border-style: solid;
  --border-width: 1px;
}

ion-card-header {
  border-radius: 10px 10px 0 0;
  background-color: var(--color-blue-7-light);
}

ion-card-header ion-icon {
  font-size: 22px;
  color: var(--color-gray-4-light);
  cursor: pointer;
  vertical-align: middle;
}

ion-card-header {
  height: 3.375rem;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 0 1rem !important;
}
ion-card-header ion-text {
  display: flex;
  align-content: center;
}
ion-card-header ion-text img {
  margin-right: 0.5rem;
}

ion-card-content {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.4 !important;
  background-color: var(--color-white-light) !important;
}

digim-operations-home-card {
  padding: 2px;
}
digim-operations-home-card ion-card-content ion-row {
  height: 100px;
  width: 100% !important;
  padding: 10px;
}
digim-operations-home-card ion-card-content ion-row ion-card {
  height: 100px;
  width: 100%;
}

.widget-cont {
  width: 310px;
  height: 274px;
  position: relative;
}

/*
 * Media selectors: #media
 */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  /* Safari and Chrome, if Chrome rule needed */
  .digim-operations-home-card {
    max-height: 440px;
    max-width: 290px;
  }
  /* Safari 5+ ONLY */
}
@media only screen and (min-device-width: 320px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 1) {
  .digim-text-card-title {
    font-size: 50px;
  }
}
@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: portrait) {
  .digim-ionic-card-center ion-card {
    height: 330px;
  }
}
@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: landscape) {
  .digim-ionic-card-center ion-card {
    height: 330px;
  }
}
@media (max-width: 320px) {
  .responsive_card {
    display: inline-block;
    width: 99vw;
  }
}
@media (min-width: 321px) {
  .responsive_card {
    display: inline-block;
    width: 99vw;
  }
}
@media (min-width: 480px) {
  .responsive_card {
    display: inline-block;
    width: 99vw;
  }
}
@media (min-width: 767px) {
  .responsive_card {
    display: inline-block;
    width: 99vw;
  }
}
@media (min-width: 768px) {
  .responsive_card {
    display: inline-block;
    width: 50vw;
  }
  .digim-center {
    bottom: 10px;
  }
  .swiper-container {
    width: 750px !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {
  .digim-button-1 {
    font-size: 13px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {
  .digim-button-1 {
    font-size: 15px;
  }
}
@media (min-width: 920px) {
  .responsive_card {
    display: inline-block;
    width: 33vw;
  }
}
@media (min-width: 1200px) {
  .responsive_card {
    display: inline-block;
    width: 25vw;
  }
}
.dark .digim-card-heading {
  color: var(--color-black-dark);
}
.dark .digim-text-card-title {
  color: var(--color-black-dark);
}
.dark .digim-small-text {
  color: var(--color-black-dark);
}
.dark .digim-button-1 {
  --background: var(--color-blue-1-dark);
  --border-color: var(--color-blue-1-dark);
}
.dark ion-card-header {
  background-color: var(--color-blue-7-dark);
}
.dark ion-card-header ion-icon {
  color: var(--color-gray-4-dark);
}
.dark ion-card-content {
  background-color: var(--color-white-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/widgets/widget.styles.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/widgets/widget.styles.scss"],"names":[],"mappings":"AAAA;;;;;;;;EAAA;AAUA;;EAAA;AAIC,gBAAA;AACD;;;EAGE,aAAA;ACDF;;ADOA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;ACJF;;ADOA;EACE,UAAA;ACJF;;ADOA;EACE,cAAA;EACA,UAAA;ACJF;;ADOA;EACE,2BAAA;EACA,4BAAA;ACJF;;ADOA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;ACJF;;ADOA;EACE,YAAA;EACA,uBAAA;ACJF;;ADOA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;ACJF;;ADOA;EACE,YAAA;EACA,uBAAA;ACJF;;ADOA;EACE,aAAA;EACA,WAAA;ACJF;;ADOA;EACE,eAAA;EACA,+BAAA;EACA,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;ACJF;;ADOA;EACE,cAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;ACJF;;ADQA;EACE,sBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;ACLF;;ADQA;EACE,cAAA;EACA,kBAAA;ACLF;;ADQA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;ACLF;;ADQA;EACE,uCAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,yCAAA;EACA,qBAAA;EACA,mBAAA;ACLF;;ADQA;EACE,4BAAA;EACA,2CAAA;ACLF;;ADQA;EACE,eAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;ACLF;;ADQA;EACE,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;ACLF;ADOE;EACE,aAAA;EACA,qBAAA;ACLJ;ADOI;EACE,oBAAA;ACLN;;ADUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qDAAA;ACPF;;ADUA;EACE,YAAA;ACPF;ADUI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ACRN;ADUM;EACE,aAAA;EACA,WAAA;ACRR;;ADcA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;ACXF;;ADcA;;EAAA;AAIA;EAEE,6CAAA;EACA;IACE,iBAAA;IACA,gBAAA;ECbF;EDgBA,mBAAA;ACdF;ADiBA;EACE;IACE,eAAA;ECfF;AACF;ADkBA;EACE;IACE,aAAA;EChBF;AACF;ADmBA;EACE;IACE,aAAA;ECjBF;AACF;ADoBA;EACE;IACE,qBAAA;IACA,WAAA;EClBF;AACF;ADqBA;EACE;IACE,qBAAA;IACA,WAAA;ECnBF;AACF;ADsBA;EACE;IACE,qBAAA;IACA,WAAA;ECpBF;AACF;ADuBA;EACE;IACE,qBAAA;IACA,WAAA;ECrBF;AACF;ADyBA;EACE;IACE,qBAAA;IACA,WAAA;ECvBF;ED2BA;IACE,YAAA;ECzBF;ED4BA;IACE,uBAAA;EC1BF;AACF;AD6BA;EAEE;IACE,eAAA;EC5BF;AACF;AD+BA;EAEE;IACE,eAAA;EC9BF;AACF;ADiCA;EACE;IACE,qBAAA;IACA,WAAA;EC/BF;AACF;ADmCA;EACE;IACE,qBAAA;IACA,WAAA;ECjCF;AACF;ADqCE;EACE,8BAAA;ACnCJ;ADsCE;EACE,8BAAA;ACpCJ;ADuCE;EACE,8BAAA;ACrCJ;ADwCE;EACE,sCAAA;EACA,wCAAA;ACtCJ;ADyCE;EACE,0CAAA;ACvCJ;AD0CE;EACE,+BAAA;ACxCJ;AD2CE;EACE,oDAAA;ACzCJ","sourcesContent":["/*\r\n *  Shared Seacom Widget styles\r\n *\r\n *  Index (Ctrl+F to locate): \r\n *   #normal Normal (and Light Theme) Styles\r\n *   #dark Dark Theme Styles\r\n *   #media Media Selectors Styles\r\n *\r\n */\r\n\r\n/*\r\n * Normal Styles: #normal\r\n */\r\n\r\n /* Safari 7.1+ */\r\n_::-webkit-full-page-media,\r\n_:future,\r\n:root ion-card {\r\n  height: 330px;\r\n}\r\n\r\n$COLOR_4: #000000;\r\n$COLOR_5: #fff;\r\n\r\n.digim-notification-top-right {\r\n  position: absolute;\r\n  top: -10px;\r\n  right: 10px;\r\n  height: 30px;\r\n  width: 30px;\r\n  transition: 0.6s;\r\n  font-size: 1rem;\r\n  z-index: 1;\r\n}\r\n\r\n.dispatcher-home-card ion-card-header {\r\n  padding: 0;\r\n}\r\n\r\n.dispatcher-home-card ion-card-content {\r\n  flex: 1 1 auto;\r\n  padding: 0;\r\n}\r\n\r\n.responsive_card {\r\n  background: none !important;\r\n  margin: auto auto !important;\r\n}\r\n\r\n.widget-content {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.widget-content-row {\r\n  flex-grow: 1;\r\n  justify-content: center;\r\n}\r\n\r\n.widget-button-row {\r\n  flex-shrink: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\ndiv.digim-ionic-card-center {\r\n  height: 100%;\r\n  align-items: flex-start;\r\n}\r\n\r\n.digim-ionic-card-center ion-card-content {\r\n  height: 200px;\r\n  width: 100%\r\n}\r\n\r\n.digim-card-heading {\r\n  font-size: 22px;\r\n  color: var(--color-black-light);\r\n  display: inline-block;\r\n  text-transform: capitalize;\r\n  font-family: Calibri;\r\n  width: 90%;\r\n  font-weight: 600;\r\n}\r\n\r\n.digim-text-card-title {\r\n  display: block;\r\n  font-size: 4em;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  width: 100%;\r\n  font-family: Calibri;\r\n  // line-height: 110px;\r\n}\r\n\r\n.digim-small-text {\r\n  padding: 0px 0 0px 5px;\r\n  font-size: 13px;\r\n  color: var(--color-black-light);\r\n  text-align: center;\r\n  width: 100%;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.digim-center {\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n.digim-center {\r\n  display: block;\r\n  text-align: center;\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 15px;\r\n}\r\n\r\n.digim-button-1 {\r\n  --background: var(--color-blue-1-light);\r\n  --border-radius: 5px;\r\n  font-weight: lighter;\r\n  height: 32px;\r\n  width: 85px;\r\n  text-transform: capitalize;\r\n  --border-color: var(--color-blue-1-light);\r\n  --border-style: solid;\r\n  --border-width: 1px;\r\n}\r\n\r\nion-card-header {\r\n  border-radius: 10px 10px 0 0;\r\n  background-color: var(--color-blue-7-light);\r\n}\r\n\r\nion-card-header ion-icon {\r\n  font-size: 22px;\r\n  color: var(--color-gray-4-light);\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n}\r\n\r\nion-card-header {\r\n  height: 3.375rem;\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  align-items: center;\r\n  padding: 0 1rem !important;\r\n\r\n  ion-text {\r\n    display: flex;\r\n    align-content: center;\r\n\r\n    img {\r\n      margin-right: .5rem;\r\n    }\r\n  }\r\n}\r\n\r\nion-card-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1.4 !important;\r\n  background-color: var(--color-white-light) !important;\r\n}\r\n\r\ndigim-operations-home-card {\r\n  padding: 2px;\r\n\r\n  ion-card-content {\r\n    ion-row {\r\n      height: 100px;\r\n      width: 100% !important;\r\n      padding: 10px;\r\n\r\n      ion-card {\r\n        height: 100px;\r\n        width: 100%;\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n.widget-cont {\r\n  width: 310px;\r\n  height: 274px;\r\n  position: relative;\r\n}\r\n\r\n/*\r\n * Media selectors: #media\r\n */\r\n\r\n@media screen and (-webkit-min-device-pixel-ratio:0) {\r\n\r\n  /* Safari and Chrome, if Chrome rule needed */\r\n  .digim-operations-home-card {\r\n    max-height: 440px;\r\n    max-width: 290px;\r\n  }\r\n\r\n  /* Safari 5+ ONLY */\r\n}\r\n\r\n@media only screen and (min-device-width: 320px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 1) {\r\n  .digim-text-card-title {\r\n    font-size: 50px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width : 834px) and (max-device-width : 1366px) and (orientation : portrait) {\r\n  .digim-ionic-card-center ion-card {\r\n    height: 330px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width : 834px) and (max-device-width : 1366px) and (orientation : landscape) {\r\n  .digim-ionic-card-center ion-card {\r\n    height: 330px;\r\n  }\r\n}\r\n\r\n@media (max-width: 320px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 99vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 321px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 99vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 99vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 99vw;\r\n  }\r\n}\r\n\r\n// Medium devices (tablets, 768px and up)\r\n@media (min-width: 768px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 50vw;\r\n  }\r\n\r\n  // .digim-ionic-card-center ion-card-content{height:316px}\r\n  .digim-center {\r\n    bottom: 10px;\r\n  }\r\n\r\n  .swiper-container {\r\n    width: 750px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {\r\n\r\n  .digim-button-1 {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {\r\n\r\n  .digim-button-1 {\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n@media (min-width: 920px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 33vw;\r\n    //aspect-ratio: auto 2/2;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .responsive_card {\r\n    display: inline-block;\r\n    width: 25vw;\r\n  }\r\n}\r\n\r\n.dark {\r\n  .digim-card-heading {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-text-card-title {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .digim-small-text {\r\n    color: var(--color-black-dark);\r\n  }\r\n\r\n  .digim-button-1 {\r\n    --background: var(--color-blue-1-dark);\r\n    --border-color: var(--color-blue-1-dark);\r\n  }\r\n  \r\n  ion-card-header {\r\n    background-color: var(--color-blue-7-dark);\r\n  }\r\n  \r\n  ion-card-header ion-icon {\r\n    color: var(--color-gray-4-dark);\r\n  }\r\n\r\n  ion-card-content {\r\n    background-color: var(--color-white-dark) !important;\r\n  }\r\n}\r\n","/*\n *  Shared Seacom Widget styles\n *\n *  Index (Ctrl+F to locate): \n *   #normal Normal (and Light Theme) Styles\n *   #dark Dark Theme Styles\n *   #media Media Selectors Styles\n *\n */\n/*\n * Normal Styles: #normal\n */\n/* Safari 7.1+ */\n_::-webkit-full-page-media,\n_:future,\n:root ion-card {\n  height: 330px;\n}\n\n.digim-notification-top-right {\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  height: 30px;\n  width: 30px;\n  transition: 0.6s;\n  font-size: 1rem;\n  z-index: 1;\n}\n\n.dispatcher-home-card ion-card-header {\n  padding: 0;\n}\n\n.dispatcher-home-card ion-card-content {\n  flex: 1 1 auto;\n  padding: 0;\n}\n\n.responsive_card {\n  background: none !important;\n  margin: auto auto !important;\n}\n\n.widget-content {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.widget-content-row {\n  flex-grow: 1;\n  justify-content: center;\n}\n\n.widget-button-row {\n  flex-shrink: 1;\n  display: flex;\n  justify-content: center;\n}\n\ndiv.digim-ionic-card-center {\n  height: 100%;\n  align-items: flex-start;\n}\n\n.digim-ionic-card-center ion-card-content {\n  height: 200px;\n  width: 100%;\n}\n\n.digim-card-heading {\n  font-size: 22px;\n  color: var(--color-black-light);\n  display: inline-block;\n  text-transform: capitalize;\n  font-family: Calibri;\n  width: 90%;\n  font-weight: 600;\n}\n\n.digim-text-card-title {\n  display: block;\n  font-size: 4em;\n  color: var(--color-black-light);\n  text-align: center;\n  width: 100%;\n  font-family: Calibri;\n}\n\n.digim-small-text {\n  padding: 0px 0 0px 5px;\n  font-size: 13px;\n  color: var(--color-black-light);\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.digim-center {\n  display: block;\n  text-align: center;\n}\n\n.digim-center {\n  display: block;\n  text-align: center;\n  width: 100%;\n  position: absolute;\n  bottom: 15px;\n}\n\n.digim-button-1 {\n  --background: var(--color-blue-1-light);\n  --border-radius: 5px;\n  font-weight: lighter;\n  height: 32px;\n  width: 85px;\n  text-transform: capitalize;\n  --border-color: var(--color-blue-1-light);\n  --border-style: solid;\n  --border-width: 1px;\n}\n\nion-card-header {\n  border-radius: 10px 10px 0 0;\n  background-color: var(--color-blue-7-light);\n}\n\nion-card-header ion-icon {\n  font-size: 22px;\n  color: var(--color-gray-4-light);\n  cursor: pointer;\n  vertical-align: middle;\n}\n\nion-card-header {\n  height: 3.375rem;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  padding: 0 1rem !important;\n}\nion-card-header ion-text {\n  display: flex;\n  align-content: center;\n}\nion-card-header ion-text img {\n  margin-right: 0.5rem;\n}\n\nion-card-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1.4 !important;\n  background-color: var(--color-white-light) !important;\n}\n\ndigim-operations-home-card {\n  padding: 2px;\n}\ndigim-operations-home-card ion-card-content ion-row {\n  height: 100px;\n  width: 100% !important;\n  padding: 10px;\n}\ndigim-operations-home-card ion-card-content ion-row ion-card {\n  height: 100px;\n  width: 100%;\n}\n\n.widget-cont {\n  width: 310px;\n  height: 274px;\n  position: relative;\n}\n\n/*\n * Media selectors: #media\n */\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  /* Safari and Chrome, if Chrome rule needed */\n  .digim-operations-home-card {\n    max-height: 440px;\n    max-width: 290px;\n  }\n  /* Safari 5+ ONLY */\n}\n@media only screen and (min-device-width: 320px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 1) {\n  .digim-text-card-title {\n    font-size: 50px;\n  }\n}\n@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: portrait) {\n  .digim-ionic-card-center ion-card {\n    height: 330px;\n  }\n}\n@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: landscape) {\n  .digim-ionic-card-center ion-card {\n    height: 330px;\n  }\n}\n@media (max-width: 320px) {\n  .responsive_card {\n    display: inline-block;\n    width: 99vw;\n  }\n}\n@media (min-width: 321px) {\n  .responsive_card {\n    display: inline-block;\n    width: 99vw;\n  }\n}\n@media (min-width: 480px) {\n  .responsive_card {\n    display: inline-block;\n    width: 99vw;\n  }\n}\n@media (min-width: 767px) {\n  .responsive_card {\n    display: inline-block;\n    width: 99vw;\n  }\n}\n@media (min-width: 768px) {\n  .responsive_card {\n    display: inline-block;\n    width: 50vw;\n  }\n  .digim-center {\n    bottom: 10px;\n  }\n  .swiper-container {\n    width: 750px !important;\n  }\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 980px) {\n  .digim-button-1 {\n    font-size: 13px;\n  }\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {\n  .digim-button-1 {\n    font-size: 15px;\n  }\n}\n@media (min-width: 920px) {\n  .responsive_card {\n    display: inline-block;\n    width: 33vw;\n  }\n}\n@media (min-width: 1200px) {\n  .responsive_card {\n    display: inline-block;\n    width: 25vw;\n  }\n}\n.dark .digim-card-heading {\n  color: var(--color-black-dark);\n}\n.dark .digim-text-card-title {\n  color: var(--color-black-dark);\n}\n.dark .digim-small-text {\n  color: var(--color-black-dark);\n}\n.dark .digim-button-1 {\n  --background: var(--color-blue-1-dark);\n  --border-color: var(--color-blue-1-dark);\n}\n.dark ion-card-header {\n  background-color: var(--color-blue-7-dark);\n}\n.dark ion-card-header ion-icon {\n  color: var(--color-gray-4-dark);\n}\n.dark ion-card-content {\n  background-color: var(--color-white-dark) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
